import MessagesWithCustomers from './MessagesWithCustomers.container';

export default MessagesWithCustomers;
